// Task item variant tailored for the active execution view (Today / Plan rail).
// @ts-check
import { memo } from 'react';
import TaskItem from './TaskItem';

/**
 * TaskItemToday - Specialized for the active execution list on the Today/Plan Page.
 * @param {{
 *   task: Task,
 *   showPlayButton?: boolean,
 *   breadcrumb?: any,
 *   view?: string,
 *   indentationType?: string
 * } & Record<string, any>} props
 */
const TaskItemToday = (props) => {
  return <TaskItem {...props} view="today" indentationType="none" />;
};

export default memo(TaskItemToday);
